var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          loading: _vm.loading,
          search: _vm.search,
          headers: _vm.headers,
          items: _vm.domainItems
        },
        scopedSlots: _vm._u([
          {
            key: "item.record",
            fn: function fn(_ref) {
              var item = _ref.item
              return [
                item.type == "CAA"
                  ? [
                      _c("div", [
                        _c("b", [_vm._v("Flag: ")]),
                        _vm._v(_vm._s(item.flag))
                      ]),
                      _c("div", [
                        _c("b", [_vm._v("Tag: ")]),
                        _vm._v(_vm._s(item.tag))
                      ]),
                      _c("div", [
                        _c("b", [_vm._v("Value: ")]),
                        _vm._v(_vm._s(item.value))
                      ])
                    ]
                  : item.type == "MX"
                  ? [
                      _c("div", [
                        _c("b", [_vm._v("Priority: ")]),
                        _vm._v(" " + _vm._s(item.preference))
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "overflow-x-auto"
                        },
                        [
                          _c("b", [_vm._v("Destination: ")]),
                          _vm._v(" " + _vm._s(item.exchange) + " ")
                        ]
                      )
                    ]
                  : item.type == "SRV"
                  ? [
                      _c("div", [
                        _c("b", [_vm._v("Priority: ")]),
                        _vm._v(_vm._s(item.priority))
                      ]),
                      _c("div", [
                        _c("b", [_vm._v("Weight: ")]),
                        _vm._v(_vm._s(item.weight))
                      ]),
                      _c("div", [
                        _c("b", [_vm._v("Port: ")]),
                        _vm._v(_vm._s(item.port))
                      ]),
                      _c("div", [
                        _c("b", [_vm._v("Target: ")]),
                        _vm._v(_vm._s(item.target))
                      ])
                    ]
                  : _c("div", {
                      staticClass: "record",
                      domProps: {
                        innerHTML: _vm._s(item.record)
                      }
                    })
              ]
            }
          },
          {
            key: "item.actions",
            fn: function fn(_ref2) {
              var item = _ref2.item
              return [
                _c(
                  "gg-btn",
                  {
                    staticClass: "mx-1",
                    on: {
                      click: function click($event) {
                        return _vm.openEditModal(item)
                      }
                    }
                  },
                  [_vm._v(" Edit ")]
                ),
                _c(
                  "gg-btn",
                  {
                    staticClass: "mx-1",
                    on: {
                      click: function click($event) {
                        return _vm.openModal("deleteRecord", item)
                      }
                    }
                  },
                  [_vm._v(" Delete ")]
                )
              ]
            }
          }
        ])
      }),
      _c("reset-modal", {
        attrs: {
          opened: _vm.modals.reset,
          domain: _vm.domain,
          username: _vm.username
        },
        on: {
          close: function close($event) {
            return _vm.closeModal("reset")
          }
        }
      }),
      _vm.modals.addRecord
        ? _c("add-record-modal", {
            attrs: {
              opened: _vm.modals.addRecord,
              domain: _vm.selectedItem.domain,
              username: _vm.username,
              type: _vm.selectedItem.type
            },
            on: {
              close: function close($event) {
                return _vm.closeModal("addRecord")
              },
              "action-completed": _vm.reload
            }
          })
        : _vm._e(),
      _vm.modals.editRecord
        ? _c("edit-record-modal", {
            attrs: {
              opened: _vm.modals.editRecord,
              username: _vm.username,
              item: _vm.selectedItem
            },
            on: {
              close: function close($event) {
                return _vm.closeModal("editRecord")
              },
              "action-completed": _vm.reload
            }
          })
        : _vm._e(),
      _c("delete-record-modal", {
        attrs: {
          opened: _vm.modals.deleteRecord,
          domain: _vm.domain,
          username: _vm.username,
          item: _vm.selectedItem
        },
        on: {
          close: function close($event) {
            return _vm.closeModal("deleteRecord")
          },
          "action-completed": _vm.reload
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }